import { render, staticRenderFns } from "./GSheetKBDetails.vue?vue&type=template&id=18e1421b&"
import script from "./GSheetKBDetails.vue?vue&type=script&lang=js&"
export * from "./GSheetKBDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18e1421b')) {
      api.createRecord('18e1421b', component.options)
    } else {
      api.reload('18e1421b', component.options)
    }
    module.hot.accept("./GSheetKBDetails.vue?vue&type=template&id=18e1421b&", function () {
      api.rerender('18e1421b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/googleSheet/GSheetKBDetails.vue"
export default component.exports